import { ProductsConfig } from '../../../interfaces/mock.interface';

export const PHONES_MOCK: ProductsConfig[] = [
    {
        label: 'Apple iPhone 16 Noir 128 Go',
        gencode: '0195949821967',
    },
    {
        label: 'Samsung Galaxy S25 Bleu clair 128 Go',
        gencode: '8806095851143',
    },
    {
        label: 'Xiaomi Redmi Note 14 Noir 128 Go',
        gencode: '6932554408008',
    },
];
